import { Venue, VenueWithRelations } from '@models/Venue'
import { selectVenueById } from '@store/VenueReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Space, Typography } from 'antd'
import { useAppSelector } from '../../store/hooks'
import { VenueTypeTag } from './TypeTag'

const { Text } = Typography
type Props = SBModelComponent<Venue | VenueWithRelations> & {
  style?: React.CSSProperties
}

export const VenueOption = ({ id, model, style }: Props) => {
  const item = model ? model : useAppSelector(selectVenueById(id!))
  const venue = item as VenueWithRelations
  const type = venue.type
  if (!item) {
    return <></>
  }

  return (
    <Space size={10} style={style}>
      <VenueTypeTag model={type} />
      <Text>{venue.name}</Text>
    </Space>
  )
}

export type VenueOptionType = { Option: typeof VenueOption }
